import { render, staticRenderFns } from "./OrderSinglePaid.vue?vue&type=template&id=6a4224b3&"
import script from "./OrderSinglePaid.vue?vue&type=script&lang=js&"
export * from "./OrderSinglePaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports